import React from 'react';
import { Input } from 'reactstrap';
import './SelectInput.scss';

export default function SelectInput({
  data,
  keyName = null,
  valueKey,
  labelKey,
  placeholder = 'Select',
  onChange = null,
  value = null,
  hasDefault = false,
}) {
  return (
    <Input
      type="select"
      className="form-select external-filter-input"
      onChange={onChange}
      value={value}
      placeholder={placeholder}
    >
      {!hasDefault && <option value="">{placeholder}</option>}
      {data?.map(item => (
        <option key={item?.[keyName]} value={item?.[valueKey]}>
          {item?.[labelKey]}
        </option>
      ))}
    </Input>
  );
}
